import { PROFILE_DELETE_REQUEST_CODE_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"

import { useUserInfo } from "widgets/auth-provider/model/user-info-store"

import { MyProfileCardHeaderWidgetInstance } from "../MyProfileCardHeaderWidgetClass"
import { MyProfileCardHeaderWidgetViewModel } from "../ui/MyProfileCardHeaderWidgetView"

export function useMyProfileCardHeaderWidget({
  widget
}: {
  widget: MyProfileCardHeaderWidgetInstance
}): MyProfileCardHeaderWidgetViewModel {
  const user = useUserInfo()
  const { openOverlay: openProfileDeleteOverlay } = useOverlay(
    PROFILE_DELETE_REQUEST_CODE_OVERLAY
  )

  const handleOpenProfileDeleteOverlay = useEvent(() => {
    openProfileDeleteOverlay(null)
  })

  return {
    widget,
    user,
    onDeleteProfile: handleOpenProfileDeleteOverlay
  }
}
